import { render } from "./museumCourseList.vue?vue&type=template&id=7fa3034c&scoped=true"
import script from "./museumCourseList.vue?vue&type=script&lang=js"
export * from "./museumCourseList.vue?vue&type=script&lang=js"

import "./museumCourseList.vue?vue&type=style&index=0&id=7fa3034c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa3034c"]])

export default __exports__